import styled from "styled-components";
import {Button} from "@material-ui/core";
import {
    DateRangeOutlined as DateRangeOutlinedIcon,
    EventAvailable as EventAvailableIcon,
    EventBusyOutlined as EventBusyOutlinedIcon,
    EventOutlined as EventOutlinedIcon,
} from "@material-ui/icons";

export const StyledDateRangeOutlinedIcon = styled(DateRangeOutlinedIcon)`
  color: #fff;
`

export const StyledEventOutlinedIcon = styled(EventOutlinedIcon)`
  color: #fff;
`

export const StyledEventAvailableIcon = styled(EventAvailableIcon)`
  color: #fff;
`

export const StyledEventBusyOutlinedIcon = styled(EventBusyOutlinedIcon)`
  color: var(--primary-main, #FB7672);
`

export const ActionButton = styled(Button)`
  margin-bottom: 0.5rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`

export const GreenActionButton = styled(ActionButton)`
  background-color: #13CA82FF !important;
`;
